<template lang="pug">
  #app
    header
      h1
        router-link(to="/") Toma.aê
      p porque tamanho não é documento
    transition(name="slide" mode="out-in")
      router-view.content
    app-footer
</template>

<script>
import AppFooter from './components/AppFooter'

export default {
  name: 'app',
  components: {
    AppFooter
  }
}
</script>

<style lang="stylus">
@import "https://use.typekit.net/rwe2fqj.css"
@import "~jeet/jeet"

$jeet['max-width'] = 768px

body
  padding 2.5rem 0 3rem

#app
  center($pad: 3%)
  text-align center

  header
    margin-bottom 3rem

    h1
      font-family tornac, Helvetica, Arial, sans-serif

      a
        color inherit
        text-decoration none

        &:hover
          text-decoration none

    p
      font-size .8em
  .content
    margin-bottom 5rem

.tooltip
  margin-top .3em
  .tooltip-inner
    background-color black
    padding .2em .6em
    color white
    font-size .8em
    border-radius .5em
    // margin-top 1em

  .tooltip-arrow
    width 0
    height 0
    border .5rem solid transparent
    border-bottom-color black
    border-top-width 0
    margin auto

.slide-enter-active, .slide-leave-active
  transition all .3s ease

.slide-enter
  transform translateX(30%)
  opacity 0

.slide-leave-to
  transform translateX(-30%)
  opacity 0
</style>



// WEBPACK FOOTER //
// src/App.vue